import { ref, onMounted, onUnmounted } from 'vue'

export function useResponsiveItems() {
    const itemsPerPage = ref<number>(window.innerWidth < 600 ? 8 : 9)

    const updateItemsPerPage = () => {
        itemsPerPage.value = window.innerWidth < 600 ? 8 : 9
    }

    onMounted(() => {
        window.addEventListener('resize', updateItemsPerPage)
    })

    onUnmounted(() => {
        window.removeEventListener('resize', updateItemsPerPage)
    })

    return { itemsPerPage }
}

